import React from 'react'

const Notices=()=>{
    return(
        <div className="columns is-variable">
            <div className="column is-4-desktop is-6-tablet">
              <article className="message is-info">
                <div className="message-header">
                  <p>Aviso</p>
                  <button className="delete" aria-label="delete"></button>
                </div>
                <div className="message-body">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Pellentesque risus mi, tempus quis placerat
                  ut, porta nec nulla. Vestibulum rhoncus ac ex sit amet
                  fringilla. Nullam gravida purus diam, et dictum
                  felis venenatisefficitur. Aenean ac
                  eleifend lacus, in mollis lectus. Donec sodales, arcu
                  et sollicitudin porttitor, tortor urna tempor ligula, id
                  porttitor mi magna a neque. Donec dui urna, vehicula et sem
                  eget, facilisis sodales sem.
                </div>
              </article>
            </div>
            <div className="column is-4-desktop is-6-tablet">
              <article className="message is-danger">
                <div className="message-header">
                  <p>Aviso</p>
                  <button className="delete" aria-label="delete"></button>
                </div>
                <div className="message-body">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Pellentesque risus mi, tempus quis placerat
                  ut, porta nec nulla. Vestibulum rhoncus ac ex sit amet
                  fringilla. Nullam gravida purus diam, et dictum
                  felis venenatisefficitur. Aenean ac
                  eleifend lacus, in mollis lectus. Donec sodales, arcu
                  et sollicitudin porttitor, tortor urna tempor ligula, id
                  porttitor mi magna a neque. Donec dui urna, vehicula et sem
                  eget, facilisis sodales sem.
                </div>
              </article>
            </div>
            <div className="column is-4-desktop is-6-tablet">
              <article className="message is-success">
                <div className="message-header">
                  <p>Aviso</p>
                  <button className="delete" aria-label="delete"></button>
                </div>
                <div className="message-body">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Pellentesque risus mi, tempus quis placerat
                  ut, porta nec nulla. Vestibulum rhoncus ac ex sit amet
                  fringilla. Nullam gravida purus diam, et dictum
                  felis venenatisefficitur. Aenean ac
                  eleifend lacus, in mollis lectus. Donec sodales, arcu
                  et sollicitudin porttitor, tortor urna tempor ligula, id
                  porttitor mi magna a neque. Donec dui urna, vehicula et sem
                  eget, facilisis sodales sem.
                </div>
              </article>
            </div>
          </div>
        
    )

}

export default Notices